import { defineMessages } from 'react-intl';

const _default_1: {
	announcementMovedDown: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	announcementMovedToBottom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	announcementMovedToTop: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	announcementMovedUp: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveDown: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveToBottom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveToTop: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	moveUp: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	reorderingMenuTriggerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	reorderingMenuTriggerLabel: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.trigger-label',
		defaultMessage: 'Reorder menu item',
		description: 'Label for the button that opens the sub-menu for actions to reorder the menu',
	},
	moveToTop: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-top',
		defaultMessage: 'Move to top',
		description: 'Label for the actions menu item to move the item to the top of the menu',
	},
	moveUp: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-up',
		defaultMessage: 'Move up',
		description: 'Label for the actions menu item to move the item up one position in the menu',
	},
	moveDown: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-down',
		defaultMessage: 'Move down',
		description: 'Label for the actions menu item to move the item down one position in the menu',
	},
	moveToBottom: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.move-to-bottom',
		defaultMessage: 'Move to bottom',
		description: 'Label for the actions menu item to move the item to the bottom of the menu',
	},
	announcementMovedToTop: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-to-top',
		defaultMessage: '{itemLabel} moved to position {position} of {total}.',
		description:
			'Screen reader announcement when a navigation item has been moved to the top of the menu. Position will be 1.',
	},
	announcementMovedUp: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-up',
		defaultMessage: '{itemLabel} moved to position {position} of {total}.',
		description:
			'Screen reader announcement when a navigation item has been moved up one position in the menu',
	},
	announcementMovedDown: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-down',
		defaultMessage: '{itemLabel} moved to position {position} of {total}.',
		description:
			'Screen reader announcement when a navigation item has been moved down one position in the menu',
	},
	announcementMovedToBottom: {
		id: 'navigation.global-side-navigation.nav-item.actions.reordering.announcement.moved-to-bottom',
		defaultMessage: '{itemLabel} moved to position {position} of {total}.',
		description:
			'Screen reader announcement when a navigation item has been moved to the bottom of the menu. Position will equal total.',
	},
});
export default _default_1;
